var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_299_41",
    transform: "scale(0.0166667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_299_41",
    width: 60,
    height: 60,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAADbElEQVRoge2aO2gUQRyHf2MSVEx8oWAKH0gMFoqIiiABBUGxsNFGBdPYiY9CRRtJFIukVNtYiilEFEQIiCAECSoKFkaMCkbUQggSjS+SfBZ7p+e5Ozt3N7t7xvvK252Z35fZu5n/bKQaNWrUqAKArqwzpAoB/480v/k/pPmTqS/N30xt6RDhbKUjAv2i1PtLIBvpMoRfe5Tu/BeEZwDHgY8+pU2awrbrxpjQLMASSVclbfAQo3uah06sAAuBdof79gJziz83xgxL2iypz0Ocbx76CAdYBVwBxkt47L4DPcDykP4agQeVPtJJiBrgNPCjgnBjwNGQvpcCn6tNtqcC0WLOh4xxsipkc2GOeZTNc9hx7DA6kpRtBr46CEwCbwnW2QmH+78AzWUIJ7v2Audigr8BDgAzC9pMB/YBz2Laxu6WUpXNDfjYEvgTsMzSthF4aGk/6DB+qrJ12JefXoc+tljaTwDTY9o7ydaXImZhvqS6Cvu4J+mU5XqDpO+W62eMMensmYE5ltkBGAFWpBImDQjW37gNwXvgCDA7y6zeigegT9I2h1vHJd2X1C/pkaTHkl4YYyZ9ZUkFoD1mhm2MAreBDsBHVZQ8QD3wpALpQp4S/AETr+YqAmgFPniSBugHFmXtZQVowd9MAwwB87L2skLweB8CnnuSvuwrW6JHPICRtFHSVkltktZLWlBGV5OSWo0xLz3GSweCIn4X0AUM4H4i4lQmVj0EZ15nCU45bPRkndUrwM4Y4es+xnEqHoBO28Yc2C2pJeLykDHmmsMwtySNSZoVcd1WOPgD6AT7mTJwyTIzw0CDwzhN2A/+Lvjwse5kCOpLl3MhW4G+WFI3wS+2jQ4FJWAUAw45yic/s3li7l0Z8/0DuAPsAJoK2jUAbcCNmLZfgHKWs/Jk44RzbW46SOcZITjjcl2SLqYq6yjcir8XX4W8IuQVTKKyETwB6ovab6e8NwNRvANWV4NsnmMh/awDBj3I3sVy0pmFLAS7o00h/TUQFA/liA8Ae4j/VU9dNs8IsCaibwOsBU449HOQNA76KP3lVBijwP6YcawkLloUptJZztNLxCxVlXAukC/pcUIK9qoTzoXy8XiHClSlcC5YqHRmgdIgTDrrTIlTLJ11nlQolM46S2rkpbPOkSpk8b+KNWrUqBHCT3WKXWrj/oz2AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceTag);
export default __webpack_public_path__ + "static/media/price-tag.852ac0e4c9b27aa8bb919e7e8c8fce92.svg";
export { ForwardRef as ReactComponent };